import { render, staticRenderFns } from "./VuexBreadcrumb.vue?vue&type=template&id=307700b4&"
import script from "./VuexBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VuexBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports